export default {
    claimForm: {
        driverName: {
            name: 'ชื่อ - นามสกุล ผู้ขับขี่',
            placeholder: 'กรอกชื่อ-นามสกุล ผู้ขับขี่',
            required: 'กรุณาระบุชื่อ-นามสกุล ผู้ขับขี่',
            too_short: '',
            invalid: '',
        },
        driverContactNo: {
            name: 'เบอร์โทรศัพท์มือถือ',
            placeholder: 'กรอกเบอร์โทรศัพท์มือถือ',
            required: 'กรุณาระบุเบอร์โทรศัพท์มือถือ',
            too_short: 'กรุณาระบุเบอร์โทรศัพท์มือถือ 10 หลัก',
            invalid: '',
        },
        appointDate: {
            name: 'วัน - เวลานัดหมาย',
            placeholder: 'เลือกวันที่',
            required: 'กรุณาระบุวันที่',
            too_short: '',
            invalid: '',
        },
        appointTime: {
            name: '',
            placeholder: 'เลือกเวลา',
            required: 'กรุณาระบุเวลา',
            too_short: '',
            invalid: '',
        },
        appointLocation: {
            name: 'สถานที่นัดหมาย',
            placeholder: 'กรอกสถานที่นัดหมาย',
            required: 'กรุณาระบุสถานที่นัดหมาย',
            too_short: '',
            invalid: '',
        }
    },
    claimFormNonRegister: {
        appointLocation: {
            name: 'สถานที่นัดหมาย',
            placeholder: 'กรอกสถานที่นัดหมาย',
            required: 'กรุณากรอกสถานที่นัดหมาย',
            too_short: '',
            invalid: '',
        },
        claimDate: {
            name: 'วัน-เวลารับแจ้ง',
            placeholder: 'เลือกวันที่',
            required: 'กรุณาเลือกวันที่',
            too_short: '',
            invalid: '',
        },
        claimTime: {
            name: '',
            placeholder: 'เลือกเวลา',
            required: 'กรุณาเลือกเวลา',
            too_short: '',
            invalid: '',
        },
        appointDate: {
            name: 'วัน - เวลา นัดหมาย',
            placeholder: 'เลือกวันที่',
            required: 'กรุณาเลือกวันที่',
            too_short: '',
            invalid: '',
        },
        appointTime: {
            name: '',
            placeholder: 'เลือกเวลา',
            required: 'กรุณาเลือกเวลา',
            too_short: '',
            invalid: '',
        },
        nameTitle: {
            name: 'คำนำหน้า',
            placeholder: 'เลือกคำนำหน้า',
            required: 'กรุณาเลือกคำนำหน้า',
            too_short: '',
            invalid: '',
        },
        driverName: {
            name: 'ชื่อ-นามสกุลผู้ขับขี่',
            placeholder: 'กรอกชื่อ - นามสกุลผู้ขับขี่',
            required: 'กรุณากรอกชื่อ-นามสกุลผู้ขับขี่',
            too_short: '',
            invalid: '',
        },
        contactNumber: {
            name: 'เบอร์ติดต่อ',
            placeholder: 'กรอกหมายเลขโทรศัพท์',
            required: 'กรุณากรอกหมายเลขโทรศัพท์',
            too_short: 'กรุณากรอกหมายเลขโทรศัพท์ให้ครบ 10 หลัก',
            invalid: '',
        },
        citizenId: {
            name: 'หมายเลขบัตรประชาชน',
            placeholder: 'กรอกหมายเลขบัตรประชาชน',
            required: 'กรุณากรอกหมายเลขบัตรประชาชนให้ถูกต้อง',
            too_short: 'กรุณากรอกหมายเลขบัตรประชาชนให้ถูกต้อง',
            invalid: 'กรุณากรอกหมายเลขบัตรประชาชนให้ถูกต้อง',
        },
        province: {
            name: 'จังหวัดทะเบียนรถ',
            placeholder: 'เลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },
        carNo: {
            name: 'ทะเบียนรถ',
            placeholder: 'กรอกทะเบียนรถ',
            required: 'กรุณากรอกทะเบียนรถ',
            too_short: '',
            invalid: '',
        },
    }
}